import R from 'ramda'

const OPT_OUT_ACTION_TYPE = 'OPT_OUT'
const OPT_OUT_DISPLAY_TYPE = 'Opt user out'

const isOptOutWidgetAction = R.propEq('type', OPT_OUT_ACTION_TYPE)

const convertOptOutWidgetActionToFormAction = R.applySpec({
  type: R.always(OPT_OUT_DISPLAY_TYPE)
})

export { isOptOutWidgetAction, convertOptOutWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/twitter/widget-to-form/opt-out.js